import React from "react";
import { Star } from "lucide-react";

/**
 * Reusable star rating — read-only display (pass `rating`, a float) or
 * interactive input (pass `value` + `onChange`, integers 1-5).
 */
export function StarRating({ rating = 0, size = "w-3.5 h-3.5", testId }) {
  return (
    <div className="flex items-center gap-0.5" data-testid={testId}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          className={`${size} ${i <= Math.round(rating) ? "text-amber-400 fill-amber-400" : "text-slate-600"}`}
        />
      ))}
    </div>
  );
}

export function StarRatingInput({ value, onChange, size = "w-6 h-6", testId }) {
  return (
    <div className="flex items-center gap-1" data-testid={testId}>
      {[1, 2, 3, 4, 5].map((i) => (
        <button
          key={i}
          type="button"
          onClick={() => onChange(i)}
          data-testid={`${testId}-star-${i}`}
          className="focus:outline-none transition-transform hover:scale-110"
        >
          <Star className={`${size} ${i <= value ? "text-amber-400 fill-amber-400" : "text-slate-600"}`} />
        </button>
      ))}
    </div>
  );
}
